import { render } from "./EditBusinessRuleActionSendNotification.vue?vue&type=template&id=3380e952"
import script from "./EditBusinessRuleActionSendNotification.vue?vue&type=script&lang=js"
export * from "./EditBusinessRuleActionSendNotification.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__